module.exports = __webpack_public_path__ + "img/CONSIGNET_BANNER.6458a7f6.png";